"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n  height: 64px;\n  width: 64px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  &:hover {\n    opacity: 0.8;\n  }\n"], ["\n  background: ", ";\n  height: 64px;\n  width: 64px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  &:hover {\n    opacity: 0.8;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.openButton.backgroundColor;
});
var OpenButton = /** @class */ (function (_super) {
    tslib_1.__extends(OpenButton, _super);
    function OpenButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getIcon = function () {
            return (react_1["default"].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: 24, height: 24 },
                react_1["default"].createElement("path", { fill: _this.props.theme.openButton.color, d: "M4 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4zm0 2h16v12H4V6zm1 .594v2L12 13l7-4.406v-2L12 11 5 6.594z" })));
        };
        return _this;
    }
    OpenButton.prototype.render = function () {
        var onClick = this.props.onClick;
        return (react_1["default"].createElement(Wrapper, { onClick: onClick, "data-testid": "Web-Contact-Form_OpenButton" }, this.getIcon()));
    };
    return OpenButton;
}(react_1.Component));
exports["default"] = (0, styled_components_1.withTheme)(OpenButton);
var templateObject_1;
